import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#31344A\" fill-rule=\"evenodd\" clip-path=\"url(#i-999668430__a)\" clip-rule=\"evenodd\"><path d=\"M11 1.571a9.429 9.429 0 1 0 0 18.858A9.429 9.429 0 0 0 11 1.57ZM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Z\"></path><path d=\"M11 4.714c.434 0 .786.352.786.786v4.714a.786.786 0 0 1-1.572 0V5.5c0-.434.352-.786.786-.786ZM9.429 14.928a1.571 1.571 0 1 1 3.142 0 1.571 1.571 0 0 1-3.142 0Z\"></path></g><defs><clipPath id=\"i-999668430__a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }